const ChevronDownIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='8'
      viewBox='0 0 14 8'
      fill='none'
      className={className}
    >
      <path
        d='M0.900391 0.900391L6.90039 6.90039L12.9004 0.900391'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ChevronDownIcon;
